// Angular
import { Component, OnInit } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-radio',
    templateUrl: './radio.type.component.html',
})
export class FormlyFieldRadio extends FieldType implements OnInit {
    defaultOptions = {
        templateOptions: {
            options: [],
            formCheck: 'custom', // 'custom' | 'stacked' | 'inline'
        },
    };

    public hasInputField(optionValue, fieldValue): boolean {
        if (optionValue.label === 'Polisnummer') {
            console.log();
        }
        if (typeof optionValue.value === 'string') {
            return false;
        } else if (typeof optionValue.value === 'object') {
            return true;
        }

        return false;
    }

    public getFieldName(fieldValue): string {
        const fieldName = fieldValue.value;

        return fieldName.inputfield;
    }

    public getFieldId(fieldValue): string {
        const fieldName = fieldValue.value;

        return fieldName.inputfield;
    }

    ngOnInit() {
    }
}
